// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"114":"b23ee927","161":"02f08dc1","239":"e7a2ff17","241":"46440edd","355":"6dcfbe5a","396":"d97dc745","455":"ac27a1c6","673":"a02e0e13","715":"2e09da50","722":"c4662f89","857":"44e4468d","882":"fb9dec68","889":"49488557","977":"a723575a"}[chunkId] + ".chunk.js";
};